<template>
  <v-container fluid id="login" class="auth-shell">
    <v-layout :align-center="$vuetify.breakpoint.smAndUp" :justify-center="$vuetify.breakpoint.smAndUp" column class="auth-content">
      <div class="display-1 mb-2 font-weight-regular">
        <v-layout row wrap>
          <v-flex shrink>
            <v-img v-if="brandConfig && brandConfig.logos" contain class="mb-2" :src="brandConfig.logos.inline" height="60" :alt="`${currentBrand} logo`" />
          </v-flex>
        </v-layout>
      </div>
      <div>
        <span class="body-2">Admin Portal</span>
      </div>
      <router-view class="mt-4" />
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "authentication",
  data() {
    return {
      isStoreSync: false,
    };
  },
  created() {
    this.detectBrand();
  },
  computed: {
    ...mapGetters("brand", ["currentBrand", "brandConfig"]),
  },
  methods: {
    detectBrand() {
      const host = window.location.hostname.toLowerCase();
      // ✅ Adjust domains as needed
      if (host.includes("storesyncpos")) {
        this.isStoreSync = true;
      } else if (host.includes("autorepairdesk")) {
        this.isStoreSync = false;
      } else {
        // fallback to StoreSyncPOS by default
        this.isStoreSync = true;
      }
    },
  },
};
</script>
<style scoped>
#login {
  background: var(--brand-bg, var(--v-background-base, #ebedf1));
  color: var(--brand-text, inherit);
}
.auth-shell { min-height: 100vh; overflow-y: auto; padding: 32px 16px; }
.auth-content { min-height: calc(100vh - 64px); }
.theme--dark #login {
  background: var(--v-background-base, #121212);
  color: var(--v-theme-base, #ffffff);
}
@media (max-width: 599px), (max-height: 680px) {
  .auth-shell { padding-top: 20px; padding-bottom: 20px; }
  .auth-content { min-height: 0; }
}
</style>
